module.exports = __webpack_public_path__ + "img/1024x576.0386180.png";